import React, { useState } from 'react';
import Grid from '@mui/material/Grid2';

import { 
  CreatureInstance,
  SummonInstance,
  RollPlus,
  TransformInstance,
  RolledValue,
} from "@dndModels";

import ButtonBox from "@components/input/buttons/ButtonBox";

import Roller from "@dndComponents/other/Roller";
import ToastBox from "@components/display/ToastBox";

import CommonUtilities from "@utilities/common_utilities";
import DandDCharacterUtilities from "@dndUtilities/char_utilities";

interface Props {
  obj: CreatureInstance | SummonInstance | TransformInstance;
  trim?: boolean;
  disabled: boolean;
  onChange: () => void;
}

const common_util = CommonUtilities.getInstance();
const char_util = DandDCharacterUtilities.getInstance();

export default function CreatureInstanceAbilityScores({
  obj,
  trim,
  disabled,
  onChange,
}: Props) {
  const [popoverAbility, setPopoverAbility] = useState("");
  const [popoverTime, setPopoverTime] = useState(-1);
  const [roll, setRoll] = useState<RolledValue[]>([]);

  const renderAbility = (ability: string) => {
    const modifier = obj.current_ability_scores.getModifier(ability);
    const score = obj.current_ability_scores.getAbilityScore(ability);
    if (modifier !== null && score !== null) {
      return (
        <Grid
          className="centered"
          size={{
            xs: trim ? 2 : 4
          }}>
          <div style={{
              width: "95px"
            }}>
            <Grid container spacing={0} direction="column" className="curved_border">
              <Grid>
                <div className="centered" style={{
                  fontSize: "11px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }} onClick={() => {
                }}>
                  { ability }
                </div>
              </Grid>
              <Grid>
                <ButtonBox 
                  name={ common_util.addPlusMaybe(modifier) }
                  style={{
                    fontSize: "24px",
                    lineHeight: "1.1",
                    fontWeight: "bold"
                  }}
                  disabled={ disabled }
                  onClick={(event: React.MouseEvent<HTMLDivElement>) => {
                    const rolls: RollPlus[] = [];
                    const roll_plus = new RollPlus();
                    roll_plus.ability_score = popoverAbility;
                    rolls.push(roll_plus);
                    const { advantage } = obj instanceof CreatureInstance || obj instanceof SummonInstance ? { advantage: 0 } : char_util.getAdvantage(obj, "Attack", popoverAbility);
                    setRoll(char_util.rollD20({ char_interface: obj, rolls, type: "Ability Check", advantage }));
                    setPopoverAbility(ability);
                    setPopoverTime(common_util.get_time_number());
                  }} 
                />
              </Grid>
              <Grid className="centered">
                <div className="curved_border centered" style={{
                  width: "35px",
                  fontSize: "11px",
                  fontWeight: "bold",
                  cursor: "pointer"
                }} onClick={() => {
                }}>
                  { score }
                </div>
              </Grid>
            </Grid>
          </div>
        </Grid>
      );
    }
    return null;
  }

  const renderExtras = () => {
    return (
      <ToastBox
        openTime={ popoverTime }
      >
        { renderRoll() }
      </ToastBox>
    );
  }

  const renderRoll = () => {
    return (
      <Roller 
        name={popoverAbility}
        rolled_values={roll}
        type="Ability Check" 
      />
    );
  }
  
  return (
    <Grid
      key="AbilityChecks"
      container
      spacing={0}
      direction="row"
      className="curved_border bg_black_transp">
      { renderAbility("Strength") }
      { renderAbility("Dexterity") }
      { renderAbility("Constitution") }
      { renderAbility("Intelligence") }
      { renderAbility("Wisdom") }
      { renderAbility("Charisma") }
      { renderExtras() }
    </Grid>
  );
}
